<mat-accordion>
    @for (note of getSortedNotes(notes); track note) {
        <mat-expansion-panel>
            <mat-expansion-panel-header class="panel-heading">
                <mat-panel-title class="start-center flex-row">
                    @if (!note.isImportant) {
                        <mat-icon>info_outline</mat-icon>
                    }
                    @if (note.isImportant) {
                        <mat-icon color="accent">error</mat-icon>
                    }
                    <div class="cb-margin-left-2x flex-col flex">
                        <h1 class="mat-body-strong">{{ note.subject }}</h1>
                        <h2 class="mat-body-2">
                            {{ note.createdByName }}, {{ relativeDate(note.createdDate) }}
                        </h2>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="flex-col">
                <div class="cb-margin-right-3x flex-col flex">
                    <cb-display-value-new label="Note" [value]="note.body"></cb-display-value-new>
                    <cb-display-value-new label="Created">
                        {{ note.createdByName }} on {{ note.createdDate | date }}
                    </cb-display-value-new>
                    <cb-display-value-new label="Update">
                        {{ note.updatedByName }} on {{ note.updatedDate | date }}
                    </cb-display-value-new>
                </div>
                <mat-divider class="divider"></mat-divider>
                <div class="footer-buttons end-center flex-row">
                    @if (canDelete.value) {
                        <button mat-stroked-button (click)="deleteNote(note)">
                            <mat-icon>delete</mat-icon>
                            &nbsp;Delete
                        </button>
                    }
                    @if (canEdit.value) {
                        <button mat-stroked-button color="accent" (click)="editNote(note)">
                            <mat-icon>mode_edit</mat-icon>
                            &nbsp;Edit
                        </button>
                    }
                </div>
            </div>
        </mat-expansion-panel>
    }
</mat-accordion>
@if (noNotes.value) {
    <cb-info-message message="There were no Notes found"> </cb-info-message>
}
@if (!notesLoaded) {
    <div class="start-center flex-row">
        <cb-loading-spinner></cb-loading-spinner>
    </div>
}
